/* eslint-disable */

/* ---------------------------------------------------
Import modules
----------------------------------------------------- */

import SimpleSelector from 'simple-selector';
import IndexedSearchFormController from './controller';

/* ---------------------------------------------------
Search Page
----------------------------------------------------- */

(function (page) {
  // If we dont have a search page do nothing
  if (!page) return;
  // Find the search form
  var form = page.querySelector('.js-search-page__form');
  // Find the filters
  var filters = page.querySelector('.js-search-page__filters');
  // find the results list
  var results = page.querySelector('.js-search-page__results');
  // Find the keyword input
  var keyword = page.querySelector('.js-search-page__keyword');
  // Find the keyword text
  var keywordText = page.querySelector('.js-search-page__keyword-text');
  // Find the load more button
  var loadMore = page.querySelector('.js-search-page__load-more');
  // A number to display the results count
  var resultsCount = page.querySelector('.js-search-page__count');
  // A number to display the results showing
  var resultsShowing = page.querySelector('.js-search-page__showing');
  // The page length
  var length = 48;
  // A class name for the items
  var className = 'search-result';
  // The current search parameters
  var search = new URLSearchParams(window.location.search);
  // Create an array to hold the search results as html
  var paginatedResults = [];

  // A simple boolean to prevent the number of total results from updating when we filter
  var canUpdateNumberOfTotalResults = true;

  // Update the keyword input value
  keyword.value = search.get('keyword') || '';

  // Create a new IndexedSearchFormController
  var IndexedSearch = new IndexedSearchFormController(form, {
    // parametersThatUpdateFilters: ['keyword'],
  });

  // A function to add 20 more results to the page
  var appendResults = function appendResults() {
    // Add the first 20 results to the page
    results.innerHTML += paginatedResults.slice(0, length).join('');
    // Remove the first results from the array
    paginatedResults.splice(0, length);
    // Hide the load more button if there are no more results
    loadMore.classList.toggle('hidden', paginatedResults.length === 0);
  };

  // A function to update the preview text for the searched keyword
  var updateKeywordText = function updateKeywordText() {
    keywordText.innerText = keyword.value;

    // Update the page URL
    var url = new URL(window.location.href);
    url.searchParams.set('q', keyword.value);
    window.history.replaceState({}, '', url);
  };
  IndexedSearch.on('change', function () {
    // Add the loading class
    page.classList.add('loading');
    // Submit the form
    IndexedSearch.submit();
  });

  // After the form submits, do something with the results
  IndexedSearch.on('submit', function (data) {
    // Remove the loading class
    page.classList.remove('loading');

    // Update the showing count
    resultsShowing.innerText = data.length;

    // Update the results count text
    if (canUpdateNumberOfTotalResults) {
      resultsCount.innerText = data.length;
      canUpdateNumberOfTotalResults = false;
    }

    // Update the keyword text
    updateKeywordText();

    // empty the html array
    paginatedResults.length = 0;

    // Clear the results html
    results.innerHTML = '';

    // Loop through the results
    data.forEach(function (result) {
      if (result.file_link) {
        paginatedResults.push("\n          <div class=\"".concat(className, "\">\n            <a href=\"").concat(result.file_link, "\" class=\"").concat(className, "__link\" download>\n              <div class=\"").concat(className, "__media\">\n                ").concat(result.thumbnail_url ? "<img src=\"".concat(result.thumbnail_url, "\" alt=\"").concat(result.title, "\" loading=\"lazy\" class=\"").concat(className, "__image\">") : "<div class=\"".concat(className, "__placeholder\"></div>"), "\n              </div>\n\n              <div class=\"").concat(className, "__main\" data-equalize-watch=\"search-result-items\">\n                <span class=\"").concat(className, "__type\">").concat(result.item.type, "</span>\n                <span class=\"").concat(className, "__title\">").concat(result.title, "</span>\n                ").concat(result.search_summary ? "<p class=\"".concat(className, "__summary\">").concat(result.search_summary, "</p>") : '', "\n                ").concat(result.file_size ? "<span class=\"".concat(className, "__file-size\">").concat(result.file_size, "</span>") : '', "\n                ").concat(result.file_extension ? "<span class=\"".concat(className, "__file-type\">").concat(result.file_extension, "</span>") : '', "\n              </div>\n            </a>\n          </div>\n        "));
      } else {
        paginatedResults.push("\n          <div class=\"".concat(className, "\">\n            <a href=\"").concat(result.page_link, "\" class=\"").concat(className, "__link\">\n              <div class=\"").concat(className, "__media\">\n                ").concat(result.thumbnail_url ? "<img src=\"".concat(result.thumbnail_url, "\" alt=\"").concat(result.title, "\" loading=\"lazy\" class=\"").concat(className, "__image\">") : "<div class=\"".concat(className, "__placeholder\"></div>"), "\n              </div>\n\n              <div class=\"").concat(className, "__main\" data-equalize-watch=\"search-result-items\">\n                <span class=\"").concat(className, "__type\">").concat(result.item.type, "</span>\n                <span class=\"").concat(className, "__title\">").concat(result.title, "</span>\n                ").concat(result.search_summary ? "<p class=\"".concat(className, "__summary\">").concat(result.search_summary, "</p>") : '', "\n                ").concat(result.item.code ? "<span class=\"".concat(className, "__code\">").concat(result.item.code, "</span>") : '', "\n              </div>\n            </a>\n          </div>\n        "));
      }

      // new html template for the item
    });

    // Append results to the page
    appendResults();
  });

  // Take over the render function
  IndexedSearch.onRender(function (response) {
    // Create a new div
    var filters = document.createElement('div');

    // Loop through the response
    response.forEach(function () {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments.length > 1 ? arguments[1] : undefined;
      // Create a new div
      var fieldset = document.createElement('div');
      // Create a label
      var label = document.createElement('label');
      // Create a new select element
      var select = document.createElement('select');
      // Create a placeholder option
      var placeholder = document.createElement('option');

      // Set the select name
      select.name = filter.field;
      // Set the select ID
      select.id = select.name + '-' + index;
      // Set the select multiple
      select.multiple = true;

      // Set the label text
      label.innerText = filter.label;
      // Set the select placeholder
      select.setAttribute('placeholder', filter.label);
      // Set the placeholder text
      placeholder.innerText = 'All';
      // Set the placeholder value
      placeholder.value = '';
      // Select the placeholder by default
      placeholder.selected = true;

      // Append the legend to the fieldset
      fieldset.appendChild(label);

      // Add an empty option to the select
      select.appendChild(placeholder);

      // Loop all the options
      filter.options.forEach(function (option) {
        // Create a new option for the select
        var optionElement = document.createElement('option');

        // Set the option value
        optionElement.value = option.value;
        // Set the option text
        optionElement.innerText = option.value + ' (' + option.count + ')';

        // Append the option to the select
        select.appendChild(optionElement);

        // If this value is in the value object, select the option
        if (IndexedSearch.value['filter'][filter.field] == undefined) return;
        if (!IndexedSearch.value['filter'][filter.field].includes(optionElement.value)) return;

        // Unselect the placeholder
        placeholder.selected = false;

        // Select the option
        optionElement.selected = true;
      });

      // Append the select to the fieldset
      fieldset.appendChild(select);

      // Append the fieldset to the filters
      filters.appendChild(fieldset);

      // Set up a new SimpleSelector
      select.SimpleSelector = new SimpleSelector(select);
      select.SimpleSelector.on('update', function () {
        select.SimpleSelector.close();
        select.SimpleSelector.template.header.classList.add('loading');
        setTimeout(function () {
          select.SimpleSelector.template.header.classList.remove('loading');
        }, 3000);
      });
    });

    // Return the filters
    return filters;
  });

  // After the filters render, put them on the page
  IndexedSearch.on('render', function (element) {
    // Clear the filters
    filters.innerHTML = '';
    // Append the new filters
    filters.appendChild(element);
  });

  // When we click the load more button, add more results to the page
  loadMore.addEventListener('click', appendResults);

  // When we type in the keyword input, clear the filters
  keyword.addEventListener('input', function () {
    // Clear the filters
    IndexedSearch.clearFilters();
  });

  // Submit the form
  IndexedSearch.submit();
})(document.querySelector('.js-search-page'));